export class DialogApproveConfirm {
    constructor(
      public data: any
    ) {}
  }
  